(() => {
  'use strict';
  if (!document.body || document.body.dataset.hgAppReady) return;
  document.body.dataset.hgAppReady = 'true';
  document.body.classList.add('js-enabled');
  const page = document.body.dataset.page || 'home';
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#mobile-menu');
  const main = document.querySelector('main');
  const footer = document.querySelector('footer');
  function setMenu(open, restoreFocus = true) {
    if (!menu || !toggle) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Close ×' : 'Menu +';
    document.body.classList.toggle('nav-open', open);
    if (main) main.inert = open;
    if (footer) footer.inert = open;
    if (open) menu.querySelector('a')?.focus(); else if (restoreFocus) toggle.focus();
  }
  toggle?.addEventListener('click', () => setMenu(!!menu?.hidden));
  window.matchMedia('(max-width:760px)').addEventListener('change', event => {
    if (event.matches || !menu || menu.hidden) return;
    const focused = document.activeElement;
    const restoreNavigationFocus = focused === toggle || menu.contains(focused);
    const focusedRoute = restoreNavigationFocus && focused !== toggle ? routeOf(focused) : null;
    setMenu(false, false);
    if (restoreNavigationFocus) {
      const equivalent = focusedRoute && [...document.querySelectorAll('.nav a[href]')]
        .find(link => routeOf(link) === focusedRoute && link.getClientRects().length > 0);
      (equivalent || document.querySelector('.brand'))?.focus();
    }
  });
  document.addEventListener('keydown', event => {
    if (!menu || menu.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); setMenu(false); }
    if (event.key === 'Tab') {
      const items = [toggle, ...menu.querySelectorAll('a')];
      const first = items[0], last = items.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  // A current page and its parent collection are different navigation states.
  // Resolve each navigation independently, so a mobile Gifts link takes priority
  // over its Shop parent, while the desktop Shop link remains a current section.
  const parentPage = {product:'shop',coffee:'shop',chai:'shop',gifts:'shop',cafe:'locations'}[page];
  function routeOf(link) { return window.HGPageForURL(link.getAttribute('href')); }
  document.querySelectorAll('.nav, .mobile-menu').forEach(nav => {
    const links = [...nav.querySelectorAll('a[href]')];
    links.forEach(link => link.removeAttribute('aria-current'));
    const exact = links.find(link => routeOf(link) === page);
    const active = exact || (parentPage && links.find(link => routeOf(link) === parentPage));
    active?.setAttribute('aria-current', exact ? 'page' : 'true');
  });
  if (window.HGJourneys && page !== 'home') window.HGJourneys.render(page);

  const matches = {
    spiced: {name:'Masala Chai Mix', image:'assets/products/masala.webp', text:'For the spice lover. Put the kettle on and bring a little Hidden Grounds into your kitchen.', url:'product.html?id=masala', label:'Explore house chai'},
    coffee: {name:'Roaster Recommended', image:'assets/products/roaster.webp', text:'For the coffee curious. Let the roaster choose your next bag, then brew it your way.', url:'product.html?id=roaster', label:'Meet your next coffee'},
    cold: {name:'New Orleans Concentrate', image:'assets/products/nola.webp', text:'For the cold coffee crowd. Explore our New Orleans concentrate and serving details in the shop.', url:'product.html?id=nola', label:'Explore cold brew'}
  };
  const result = document.querySelector('#flavor-result');
  document.querySelectorAll('[data-flavor-match]').forEach(button => button.addEventListener('click', () => {
    const match = matches[button.dataset.flavorMatch];
    if (!match || !result) return;
    document.querySelectorAll('[data-flavor-match]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    result.querySelector('img').src = window.HGAsset(match.image);
    result.querySelector('img').alt = match.name;
    result.querySelector('h3').textContent = match.name;
    result.querySelector('[data-match-copy]').textContent = match.text;
    const link = result.querySelector('a');
    link.href = window.HGRoute(match.url);
    link.textContent = match.label + ' ';
    const arrow = document.createElement('span');
    arrow.className = 'hg-arrow hg-arrow--up-right';
    arrow.setAttribute('aria-hidden', 'true');
    link.append(arrow);
  }));
  // Optional analytics integration consumes non-personal interaction events.
  // Existing Shopify analytics remain owned by the native storefront.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    const type = /order\.online|doordash\.com/.test(url.hostname) ? 'order_handoff' : /squareup\.com/.test(url.hostname) ? 'gift_card_handoff' : url.origin === location.origin && url.pathname.startsWith('/products/') ? 'product_view' : null;
    if (type) window.dispatchEvent(new CustomEvent('hg:interaction', {detail:{event:type, destinationHost:url.hostname, location:link.dataset.location || null, product:link.dataset.product || null}}));
  });
})();
